import React, { useContext } from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import PdpFaq from "components/pdp-faq";
import PdpOurPromise from "../pdp-our-promise";
import ProductImages from "../product-images";
import PdpVariations from "../pdp-variations";
import GlobalContext from "services/global-context";
import {
  container, contentCol,
  imagesCol, singleProductContent,
  contentColSticky
} from "./style.mod.scss";
import ProductContext from "services/product-context";
import ReviewImages from "../review-images";
import ThreeRows from "components/three-rows-mobile";

const DefaultPdpLayout = ({ reviewSummary, settings, product, currentVariant }) => {
  const { addToCart } = useContext(GlobalContext);
  const productContext = useContext(ProductContext);
  if (!productContext) return <></>;

  const { handle, content: content } = productContext;
  const threeRowsProps = content?.threeRowsMobile;
  const urls = productContext.content?.productLink;
  const pdpSettings = settings?.PDPSettings;
  const template = product?.content?.pdpTemplate;
  const clusterReviews = product.clusterReviews;

  return (
    <div className={singleProductContent} style={{ backgroundColor: content?.bgColor && content?.bgColor?.hex }}>
      <div className={`${container} container-wide`}>
        <Row>
          <Col lg={7} className={imagesCol}>
            <ProductImages currentVariant={currentVariant} content={content} reviewSummary={reviewSummary} />
          </Col>
          <Col lg={4} className={contentCol}>
            <div className={contentColSticky}>
              <PdpVariations
                linkedProducts={urls}
                currentVariant={currentVariant}
                onAddToCart={addToCart}
                reviewSummary={reviewSummary}
                settings={settings}
                content={content}
                product={product}
              />
              {template !== "categoryColorSwatches" &&
                <>
                  <PdpOurPromise
                    variant={currentVariant}
                    handle={handle}
                    color={productContext?.content?.bgColor}
                    productHighlights={currentVariant?.productInfo?.productHighlights} />
                  <PdpFaq variantCluster={clusterReviews} variant={currentVariant} color={productContext?.content?.bgColor} />
                  <ReviewImages showReview={pdpSettings} />
                  <ThreeRows content={threeRowsProps} />
                </>}
            </div>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default DefaultPdpLayout;

